// World-map active-devices fetch (ADR 0018, Cluster 7 api half).
// The fetch was previously inline inside fetchWorld(); extracted here so the
// wire layer is quarantined in api/ per the layered split.
import { parseWorldSnapshot } from '../../shared/wire';

export async function apiGetWorldActive(n: number, s: number, e: number, w: number): Promise<{ ok: boolean; status: number; snap: ReturnType<typeof parseWorldSnapshot> | null }>{
  const qs = `n=${n}&s=${s}&e=${e}&w=${w}`;
  const res = await fetch(`/api/v1/world/active?${qs}`, { credentials: 'include' });
  if(!res.ok) return { ok: false, status: res.status, snap: null };
  const snap = parseWorldSnapshot(await res.json());
  return { ok: true, status: res.status, snap };
}
